import App from 'Publication.svelte';
import 'Assets/global.css';
import { mount } from 'svelte';

const app = mount(App, {
    target: document.getElementById('app')!,
});

export default app;
